// SPDX-FileCopyrightText: 2017-2026 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

export { faCommentAlt as farCommentAlt } from '@fortawesome/free-regular-svg-icons/faCommentAlt'
export { faFileAlt as farFileAlt } from '@fortawesome/free-regular-svg-icons/faFileAlt'
export { faMap as farMap } from '@fortawesome/free-regular-svg-icons/faMap'
export { faStickyNote as farStickyNote } from '@fortawesome/free-regular-svg-icons/faStickyNote'
export { faUser as farUser } from '@fortawesome/free-regular-svg-icons/faUser'
export { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown'
export { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft'
export { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight'
export { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp'
export { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown'
export { faArrowDown as fasArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown'
export { faArrowDown as faArrowDownToLine } from '@fortawesome/free-solid-svg-icons/faArrowDown'
export { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
export { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight'
export { faArrowRotateLeft } from '@fortawesome/free-solid-svg-icons/faArrowRotateLeft'
export { faArrowsRotate } from '@fortawesome/free-solid-svg-icons/faArrowsRotate'
export { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp'
export { faArrowUp as fasArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp'
export { faBabyCarriage } from '@fortawesome/free-solid-svg-icons/faBabyCarriage'
export { faBell } from '@fortawesome/free-solid-svg-icons/faBell'
export { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
export { faBars as faBarsSort } from '@fortawesome/free-solid-svg-icons/faBars'
export { faBars as farBars } from '@fortawesome/free-solid-svg-icons/faBars'
export { faBoxArchive } from '@fortawesome/free-solid-svg-icons/faBoxArchive'
export { faCalendar } from '@fortawesome/free-solid-svg-icons/faCalendar'
export { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt'
export { faCalendarPlus } from '@fortawesome/free-solid-svg-icons/faCalendarPlus'
export { faCalendarTimes } from '@fortawesome/free-solid-svg-icons/faCalendarTimes'
export { faCar } from '@fortawesome/free-solid-svg-icons/faCar'
export { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
export { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
export { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
export { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft'
export { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
export { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp'
export { faChild } from '@fortawesome/free-solid-svg-icons/faChild'
export { faChild as fasChild } from '@fortawesome/free-solid-svg-icons/faChild'
export { faEllipsis as faCircleEllipsis } from '@fortawesome/free-solid-svg-icons/faEllipsis'
export { faEllipsisVertical as faCircleEllipsisVertical } from '@fortawesome/free-solid-svg-icons/faEllipsisVertical'
export { faCircleExclamation } from '@fortawesome/free-solid-svg-icons/faCircleExclamation'
export { faClock } from '@fortawesome/free-solid-svg-icons/faClock'
export { faCoins } from '@fortawesome/free-solid-svg-icons/faCoins'
export { faComment } from '@fortawesome/free-solid-svg-icons/faComment'
export { faComment as fasComment } from '@fortawesome/free-solid-svg-icons/faComment'
export { faCommentAlt } from '@fortawesome/free-solid-svg-icons/faCommentAlt'
export { faCommentAlt as fasCommentAltLines } from '@fortawesome/free-solid-svg-icons/faCommentAlt'
export { faComments } from '@fortawesome/free-solid-svg-icons/faComments'
export { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy'
export { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase'
export { faCircle as faDash } from '@fortawesome/free-regular-svg-icons'
export { faDiagnoses } from '@fortawesome/free-solid-svg-icons/faDiagnoses'
export { faDownLeftAndUpRightToCenter } from '@fortawesome/free-solid-svg-icons/faDownLeftAndUpRightToCenter'
export { faEllipsisV as faEllipsisVAlt } from '@fortawesome/free-solid-svg-icons/faEllipsisV'
export { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
export { faEnvelope as fasEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
export { faEuroSign } from '@fortawesome/free-solid-svg-icons/faEuroSign'
export { faExchangeAlt as faExchange } from '@fortawesome/free-solid-svg-icons/faExchangeAlt'
export { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation'
export { faExclamation as fasExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation'
export { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
export { faExclamationTriangle as fasExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
export { faExternalLinkAlt as faExternalLink } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt'
export { faEye } from '@fortawesome/free-solid-svg-icons/faEye'
export { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash'
export { faFemale } from '@fortawesome/free-solid-svg-icons/faFemale'
export { faFile } from '@fortawesome/free-solid-svg-icons/faFile'
export { faFile as fasFile } from '@fortawesome/free-solid-svg-icons/faFile'
export { faFileAlt } from '@fortawesome/free-solid-svg-icons/faFileAlt'
export { faFileAlt as fasFileAlt } from '@fortawesome/free-solid-svg-icons/faFileAlt'
export { faFileExport } from '@fortawesome/free-solid-svg-icons/faFileExport'
export { faFileImport } from '@fortawesome/free-solid-svg-icons/faFileImport'
export { faFileCsv as faFileSpreadsheet } from '@fortawesome/free-solid-svg-icons/faFileCsv'
export { faFileImage } from '@fortawesome/free-solid-svg-icons/faFileImage'
export { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf'
export { faFileWord } from '@fortawesome/free-solid-svg-icons/faFileWord'
export { faGavel } from '@fortawesome/free-solid-svg-icons/faGavel'
export { faGavel as farGavel } from '@fortawesome/free-solid-svg-icons/faGavel'
export { faGear } from '@fortawesome/free-solid-svg-icons/faGear'
export { faGear as fasGear } from '@fortawesome/free-solid-svg-icons/faGear'
export { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe'
export { faHandHolding } from '@fortawesome/free-solid-svg-icons/faHandHolding'
export { faHiking } from '@fortawesome/free-solid-svg-icons/faHiking'
export { faHome } from '@fortawesome/free-solid-svg-icons/faHome'
export { faHourglassEnd } from '@fortawesome/free-solid-svg-icons/faHourglassEnd'
export { faHourglassStart } from '@fortawesome/free-solid-svg-icons/faHourglassStart'
export { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
export { faInfo as fasInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
export { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle'
export { faLink } from '@fortawesome/free-solid-svg-icons/faLink'
export { faList } from '@fortawesome/free-solid-svg-icons/faList'
export { faLock as faLockAlt } from '@fortawesome/free-solid-svg-icons/faLock'
export { faLockOpen as faLockOpenAlt } from '@fortawesome/free-solid-svg-icons/faLockOpen'
export { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
export { faMapMarkerAlt as fasMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
export { faMeh } from '@fortawesome/free-solid-svg-icons/faMeh'
export { faMoneyBillWave } from '@fortawesome/free-solid-svg-icons/faMoneyBillWave'
export { faMoneyCheck } from '@fortawesome/free-solid-svg-icons/faMoneyCheck'
export { faMoneyCheck as faMoneyCheckEdit } from '@fortawesome/free-solid-svg-icons/faMoneyCheck'
export { faPaperclip } from '@fortawesome/free-solid-svg-icons/faPaperclip'
export { faPen } from '@fortawesome/free-solid-svg-icons/faPen'
export { faPercentage } from '@fortawesome/free-solid-svg-icons/faPercentage'
export { faPercentage as faAbacus } from '@fortawesome/free-solid-svg-icons/faPercentage'
export { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
export { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay'
export { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
export { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle'
export { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint'
export { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion'
export { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle'
export { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo'
export { faRefresh } from '@fortawesome/free-solid-svg-icons/faRefresh'
export { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
export { faSection } from '@fortawesome/free-solid-svg-icons/faSection'
export { faSignInAlt as faSignIn } from '@fortawesome/free-solid-svg-icons/faSignInAlt'
export { faSignOutAlt as faSignOut } from '@fortawesome/free-solid-svg-icons/faSignOutAlt'
export { faSignOut as farSignOut } from '@fortawesome/free-solid-svg-icons/faSignOut'
export { faStickyNote } from '@fortawesome/free-solid-svg-icons/faStickyNote'
export { faSun as faTreePalm } from '@fortawesome/free-solid-svg-icons/faSun'
export { faSync } from '@fortawesome/free-solid-svg-icons/faSync'
export { faThermometer } from '@fortawesome/free-solid-svg-icons/faThermometer'
export { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
export { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
export { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck'
export { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo'
export { faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons/faUpRightAndDownLeftFromCenter'
export { faUser } from '@fortawesome/free-solid-svg-icons/faUser'
export { faUser as fasUser } from '@fortawesome/free-solid-svg-icons/faUser'
export { faUserMinus as fasUserMinus } from '@fortawesome/free-solid-svg-icons/faUserMinus'
export { faUserAltSlash } from '@fortawesome/free-solid-svg-icons/faUserAltSlash'
export { faUserFriends } from '@fortawesome/free-solid-svg-icons/faUserFriends'
export { faUserLock as faUserUnlock } from '@fortawesome/free-solid-svg-icons/faUserLock'
export { faUserMinus } from '@fortawesome/free-solid-svg-icons/faUserMinus'
export { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers'
export { faUsers as farUsers } from '@fortawesome/free-solid-svg-icons/faUsers'
export { faXmark as farXmark } from '@fortawesome/free-solid-svg-icons/faXmark'
export { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown'
export { faCalendar as fasCalendar } from '@fortawesome/free-solid-svg-icons/faCalendar'
export { faCaretDown as fasCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown'
export { faCaretLeft as fasCaretLeft } from '@fortawesome/free-solid-svg-icons/faCaretLeft'
export { faCaretRight as fasCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight'
export { faCaretUp as fasCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp'
export { faCheck as fasCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
export { faCheckCircle as fasCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
export { faChevronDown as fasChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
export { faChevronUp as fasChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp'
export { faMagnifyingGlassPlus } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlassPlus'
export { faMagnifyingGlassMinus } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlassMinus'
export { faTimeline as faListTimeline } from '@fortawesome/free-solid-svg-icons/faTimeline'
export { faReply } from '@fortawesome/free-solid-svg-icons/faReply'
export { faUtensils } from '@fortawesome/free-solid-svg-icons/faUtensils'
export { faLineChart } from '@fortawesome/free-solid-svg-icons/faLineChart'
export { faHeart } from '@fortawesome/free-regular-svg-icons/faHeart'

import type * as FreeIconsSet from './free-icons'
import { typeAssert } from './utils'

import type { IconSet } from '.'

typeAssert<typeof FreeIconsSet extends IconSet ? true : false>(true)
